// removed by extract-text-webpack-plugin
module.exports = {"overlay":"overlay__overlay___2_gic","button-close":"overlay__button-close___1XK1b"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Overlay/overlay.scss
// module id = 934
// module chunks = 0